import React from "react";
import { Card } from "react-bootstrap";

interface IEpaCard {
  title?: string;
  content?: JSX.Element;
}

const EpaCard = ({ title, content }: IEpaCard) => (
  <Card className="flex-fill w-100">
    <Card.Header>
      <Card.Title>
        <h4>{title}</h4>
      </Card.Title>
    </Card.Header>
    <Card.Body className="pt-0">{content}</Card.Body>
  </Card>
);

export default EpaCard;
